var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import PropTypes from 'prop-types';
import contextTypes from './contextTypes';
export default _extends({}, contextTypes, {
  header: PropTypes.bool
});